import React from "react";
import { Formik, Form } from "formik";
import { Link as RouterLink } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useLogin } from "../../hooks/pages/useLogin";
import { useThemeColor } from "../../hooks/useThemeColor";

export default function SignIn() {
  const { colors } = useThemeColor();
  const { initialValues, validationSchema, onSubmit } = useLogin();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: colors.primary[400],
          borderRadius: "1rem",
          p: 8
        }}
      >
        <Box sx={{ m: 1 }}>
          <img
            src="https://sgimais.com.br/images/logo.png"
            alt="logo"
            style={{ width: 100 }}
          />
        </Box>
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting
          }) => {
            return (
              <Form>
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  label="E-mail"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  color="success"
                  style={{
                    backgroundColor: colors.blueAccent[900]
                  }}
                  value={values.email}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.email && errors.email}
                  error={Boolean(touched.email && errors.email)}
                />
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  name="password"
                  label="Senha"
                  type="password"
                  autoComplete="current-password"
                  style={{
                    backgroundColor: colors.blueAccent[900]
                  }}
                  value={values.password}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.password && errors.password}
                  error={Boolean(touched.password && errors.password)}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: colors.greenAccent[600]
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Processando..." : "Entrar"}
                </Button>
                <Grid container>
                  <Grid item xs>
                    <Link
                      sx={{ color: colors.grey[100] }}
                      component={RouterLink}
                      to="/forgot"
                      variant="body2"
                    >
                      Esqueci minha senha
                    </Link>
                  </Grid>
                </Grid>
                <Button
                  component={RouterLink}
                  to="/register"
                  type="button"
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: colors.blueAccent[600],
                    color: colors.grey[100],
                    fontWeight: "bold"
                  }}
                >
                  Teste por 5 dias
                </Button>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Container>
  );
}
